













































































import Vue from 'vue';
import {
  Component, Inject, Prop, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { KasasaAccountUpgradeFromAccountProductCode, KasasaUpgrade, KasasaUpgradeResource } from '@/api/kasasaupgrade';
import { DateTool, KasasaAccountUpgradeUtil } from '@/util';
import { DisplayAccountProductCode } from '@/util/kasasaaccountupgrade/DisplayAccountProductCode';
import TextBoxDatePicker from './TextBoxDatePicker.vue';

@Component({
  computed: mapState([
    'fiId',
  ]),
  components: {
    TextBoxDatePicker,
  },
})
export default class KasasaUpgradeCreateDialog extends Vue {
    value!: KasasaUpgrade;

    dialog:boolean = false;

    valid:boolean = true;

    saving:boolean = false;

    @Prop() upgrade!: KasasaUpgrade;

    @Prop({ default: false }) isEdit!:boolean;

    @Prop() nonKasasaProductCodes!: DisplayAccountProductCode[];

    @Prop() kasasaProducts!: DisplayAccountProductCode[];

    @Prop({ default: false }) disabled!:boolean;

    workingUpgrade: KasasaUpgrade | null = null;

    fiId!: string;

    workingFromAccountProductCodes: KasasaAccountUpgradeFromAccountProductCode[] = [];

    validateEndDateIsOnOrAfterStartDate(value: any) : boolean | string {
      return KasasaAccountUpgradeUtil.validateEndDateIsOnOrAfterStartEndDate(value, this.workingUpgrade!.startDate!);
    }

    validateStartDateIsOnOrBeforeEndDate(value: any) : boolean | string {
      return KasasaAccountUpgradeUtil.validateStartDateIsOnOrBeforeEndDate(value, this.workingUpgrade!.endDate!);
    }

    requiredRule = (value: any) => {
      if (!value || (Array.isArray(value) && value.length === 0) || value === '') {
        return 'Required';
      }
      return true;
    };

    @Inject('KasasaUpgradeResource')
    kasasaUpgradeResource!: KasasaUpgradeResource;

    mounted() {
      this.loadData();
    }

    isDirty(): boolean {
      if (!this.upgrade) {
        return true;
      }

      if (this.upgrade.endDate !== this.workingUpgrade?.endDate) {
        return true;
      }

      if (this.upgrade.startDate !== this.workingUpgrade?.startDate) {
        return true;
      }

      if (this.upgrade.toKasasaProducts !== this.workingUpgrade?.toKasasaProducts) {
        if (this.upgrade.toKasasaProducts.length !== this.workingUpgrade?.toKasasaProducts.length) {
          return true;
        }
        for (let i = 0; i < this.upgrade.toKasasaProducts.length; i++) {
          const item = this.upgrade.toKasasaProducts[i];
          if (this.workingUpgrade?.toKasasaProducts.indexOf(item) === -1) {
            return true;
          }
        }
      }

      if (this.upgrade.fromAccountProductCodes.length !== this.workingFromAccountProductCodes.length) {
        return true;
      }

      for (let i = 0; i < this.upgrade.fromAccountProductCodes.length; i++) {
        const savedItem = this.upgrade.fromAccountProductCodes[i];
        let found = false;
        for (let j = 0; j < this.workingFromAccountProductCodes.length && !found; j++) {
          const workingItem = this.workingFromAccountProductCodes[j];
          if (savedItem.isEquivalentWithoutId(workingItem)) {
            found = true;
          }
        }
        if (!found) {
          return true;
        }
      }

      for (let i = 0; i < this.workingFromAccountProductCodes.length; i++) {
        let found = false;
        const workingItem = this.workingFromAccountProductCodes[i];
        for (let j = 0; i < this.upgrade.fromAccountProductCodes.length && !found; j++) {
          const savedItem = this.upgrade.fromAccountProductCodes[j];
          if (workingItem.isEquivalentWithoutId(savedItem)) {
            found = true;
          }
        }
        if (!found) {
          return true;
        }
      }

      return false;
    }

    isUpgradePastEffectiveDate(): boolean {
      if (!this.upgrade || !this.upgrade.startDate) {
        return false;
      }

      const today = DateTool.getAustinDate();
      const upgradeStartDate = DateTool.parseDate(this.upgrade!.startDate);

      return today >= upgradeStartDate;
    }

    @Watch('fiId')
    loadData() {
      this.workingUpgrade = KasasaUpgradeResource.createEmptyUpgrade(this.fiId);
      if (this.upgrade) {
        Object.assign(this.workingUpgrade, this.upgrade);
      }
    }

    @Watch('dialog')
    onDialogToggle() {
      this.workingUpgrade = KasasaUpgradeResource.createEmptyUpgrade(this.fiId);
      this.workingFromAccountProductCodes.splice(0);
      this.saving = false;
      if (this.dialog) {
        if (this.upgrade) {
          Object.assign(this.workingUpgrade!, this.upgrade);
          this.workingUpgrade!.toKasasaProducts = Object.assign([], this.upgrade.toKasasaProducts);

          const accountProductCodes: KasasaAccountUpgradeFromAccountProductCode[] = [];
          for (let i = 0; i < this.upgrade.fromAccountProductCodes.length; i++) {
            const item = this.upgrade.fromAccountProductCodes[i];
            const accountProductCodeCopy: KasasaAccountUpgradeFromAccountProductCode = KasasaAccountUpgradeFromAccountProductCode.from(item);
            accountProductCodes.push(accountProductCodeCopy);
            this.workingFromAccountProductCodes.push(KasasaAccountUpgradeFromAccountProductCode.fromWithoutId(item));
          }
          Object.assign(this.workingUpgrade.fromAccountProductCodes, accountProductCodes);
        }
      }
    }

    onSave() {
      this.saving = true;
      this.syncAccountProductCodeLists();
      this.kasasaUpgradeResource.save(this.fiId, this.workingUpgrade!)
        .then((savedUpgrade: KasasaUpgrade) => {
          this.$emit('success', savedUpgrade);
        })
        .catch((error:any) => {
          this.$emit('onError', error);
        })
        .finally(() => {
          this.dialog = false;
          this.saving = false;
        });
    }

    @Watch('workingUpgrade.startDate')
    async watchStartDate() {
      if (this.workingUpgrade!.startDate && !this.workingUpgrade!.endDate) {
        const startDate: Date = DateTool.parseDate(this.workingUpgrade!.startDate);
        startDate.setDate(startDate.getDate() + 7);

        this.workingUpgrade!.endDate = DateTool.toIsoDateString(startDate);
      }
    }

    @Watch('workingUpgrade.endDate')
    @Watch('workingUpgrade.startDate')
    async watchDateInputs() {
      await this.$nextTick();
      const aForm : any = (this.$refs.form as any);
      if (aForm) {
        aForm.validate();
      }
    }

    syncAccountProductCodeLists() {
      const toRemove: KasasaAccountUpgradeFromAccountProductCode[] = [];
      const toAdd: KasasaAccountUpgradeFromAccountProductCode[] = [];

      if (!this.workingUpgrade) {
        return;
      }

      const workingAccountProductCodes = !this.workingFromAccountProductCodes ? [] : this.workingFromAccountProductCodes;
      const savedAccountProductCodes = (!this.upgrade || !this.upgrade.fromAccountProductCodes) ? [] : this.upgrade.fromAccountProductCodes;

      workingAccountProductCodes.forEach((item) => {
        let found = false;
        for (let i = 0; i < savedAccountProductCodes.length && !found; i++) {
          const existingItem = savedAccountProductCodes[i];
          if (item.isEquivalentWithoutId(existingItem)) {
            found = true;
          }
        }
        if (!found) {
          toAdd.push(item);
        }
      });

      savedAccountProductCodes.forEach((existingItem) => {
        let found = false;
        for (let i = 0; i < workingAccountProductCodes.length && !found; i++) {
          const searchItem = workingAccountProductCodes[i];
          if (existingItem.isEquivalentWithoutId(searchItem)) {
            found = true;
          }
        }
        if (!found) {
          toRemove.push(existingItem);
        }
      });

      toRemove.forEach((item) => {
        const index = this.workingUpgrade!.fromAccountProductCodes.indexOf(item);
        if (index !== -1) {
          this.workingUpgrade!.fromAccountProductCodes.splice(index, 1);
        }
      });

      toAdd.forEach((item) => {
        this.workingUpgrade!.fromAccountProductCodes.push(item);
      });
    }
}
